export default __webpack_public_path__ + "static/learning-bbc5dd57cecb910e72ee2c2b3b398049.jpg";